<template>
  <div>
    <form
      class="form form-horizontal"
      role="form"
      @submit.prevent="saveRequest"
      id="ma-form"
      name="myForm"
      novalidate
    >
      <modal :width="width">
        <div slot="header">
          <button type="button" class="close" @click="CloseModal">
            &times;
          </button>
          <h2 class="modal-title">Sell Request</h2>
        </div>
        <div slot="body">
          <div v-if="success_message != '' && success_message != null">
            <div class="alert alert-success text-center">
              <strong>{{ success_message }}</strong>
            </div>
          </div>
          <div
            v-if="request_error_message != null && request_error_message != ''"
          >
            <div class="alert alert-danger text-center">
              <strong>{{ request_error_message }}</strong>
            </div>
          </div>
          <div v-if="errorMessage != null && errorMessage != ''">
            <div class="alert alert-danger text-center">
              <strong>{{ errorMessage }}</strong>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Department
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="DeptId"
                v-model="DeptId"
                disabled
              >
                <option
                  v-for="(option, index) in Departments"
                  :key="'dept' + index"
                  :value="option.Id"
                >
                  {{ option.Name }}
                </option>
              </select>
            </div>
            <div class="col-xs-4">
              <label>Fajr Reference No</label>

              <input
                type="text"
                class="form-control"
                name="FajrReferenceNo"
                placeholder="Reference ID"
                v-model="FajrReferenceNo"
                disabled
              />
            </div>

            <div class="col-xs-4">
              <label>
                Transaction Date
                <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                class="form-control"
                v-model="ApplicationDate"
                disabled
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Transaction Type
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="TransactionType"
                v-model="TransactionTypeId"
                disabled
              >
                <option
                  v-for="(option, index) in TRANSACTIONTYPE"
                  :key="'trans' + index"
                  :value="option.Id"
                >
                  {{ option.Name }}
                </option>
              </select>
              <span class="text-danger">{{
                errors.first("TransactionType")
              }}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Currency
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="Currency"
                v-model="CurrencyId"
                disabled
              >
                <option
                  v-for="(option, index) in Currency"
                  :key="'currency' + index"
                  :value="option.Id"
                >
                  {{ option.ShortName }}
                </option>
              </select>
              <span class="text-danger">{{ errors.first("Currency") }}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Commodity
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="Commodityid"
                v-model="Commodity"
                data-vv-as="Commodity"
                disabled
              >
                <option
                  v-for="(option, index) in BankCommodities"
                  :key="'com' + index"
                  :value="option.Id"
                >
                  {{ option.Name }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group" v-if="TransactionTypeId == 2">
            <div class="col-xs-8">
              <label>Client Name</label>
              <input
                type="text"
                class="form-control"
                v-model="ClientName"
                disabled
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Amount
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                name="Amount"
                placeholder="Amount"
                v-model="Amount"
                disabled
              />
            </div>
            <div class="col-xs-4">
              <label>Unit Price</label>
              <input
                type="text"
                class="form-control"
                v-model="UnitPrice"
                name="UnitPrice"
                placeholder="Unit Price"
                disabled
              />
            </div>
            <div class="col-xs-4">
              <label>
                Quantity
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                name="Quantity"
                placeholder="Quantity"
                v-model="Quantity"
                disabled
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Value Date
                <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                class="form-control"
                v-model="ValueDate"
                data-vv-as="Value Date"
                name="ValueDate"
                disabled
              />
            </div>
            <!-- <div class="col-xs-4">
              <label>Maturity Date</label>
              <input
                type="date"
                class="form-control"
                v-model="MaturityDate"
                name="MaturityDate"
                disabled
              />
            </div>-->

            <div class="col-xs-4">
              <label>Your Reference</label>
              <input
                type="text"
                class="form-control"
                v-model="YourRefrence"
                name="YourRefrence"
                disabled
              />
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-8">
              <label>Comments</label>
              <input
                type="text"
                class="form-control"
                v-model="Comments"
                name="Comments"
                disabled
              />
            </div>
          </div>
        </div>
        <div slot="footer">
          <loading v-if="loading"></loading>
          <input
            type="submit"
            class="btn btn-primary"
            value="Sell"
            v-if="RoleId == 4 || RoleId == 5"
          />
          <button
            type="button"
            class="btn btn-danger"
            @click="DeleteConfirm = true"
            v-if="RoleId == 4 || RoleId == 5"
          >
            Cancel transaction
          </button>
          <button type="button" class="btn btn-warning" @click="CloseModal">
            Back
          </button>
        </div>
      </modal>
    </form>
    <modal v-if="DeleteConfirm">
      <div slot="header">
        <h3>Delete Transaction</h3>
      </div>
      <div slot="body">
        <div>
          <div v-if="CONFIRMATIONERROR != null && CONFIRMATIONERROR != ''">
            <div class="alert alert-danger text-center">
              <strong>{{ CONFIRMATIONERROR }}</strong>
            </div>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="CancelComments"
            autocomplete="off"
            name="CancelComments"
            v-validate="'valid_FirstChar|max:250'"
            placeholder="Cancel Comments"
            data-vv-as="Cancel Comments"
            maxlength="250"
            data-vv-validate-on="blur"
          />
          <span class="text-danger">{{ errors.first("CancelComments") }}</span>
        </div>
      </div>
      <div slot="footer">
        <loading v-if="CONFIRMATIONLOADING"></loading>
        <button class="btn btn-danger" @click="Delete">
          Cancel Transaction
        </button>
        <button class="btn btn-warning" @click="GoBack">Back</button>
      </div>
    </modal>
  </div>
</template>


<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      width: 800,
      success_message: null,
      DeleteConfirm: false,
      request_error_message: null,
      ClientName: "",
      DeptId: null,
      ApplicationDate: new Date(),
      CurrencyId: 1,
      Commodity: null,
      ExchageRate: null,
      Amount: null,
      Quantity: 0,
      ValueDate: null,
      MaturityDate: null,
      UnitPrice: 0.0,
      YourRefrence: null,
      Comments: null,
      FajrReferenceNo: "",
      FajrReferenceId: null,
      //options: { inputClass: "form-control", placeholder: "Client Name" },
      TransactionTypeId: 1,
      SellAccepted: null,
      CancelComments: null,

      // countries: countries
    };
  },
  props: { RequestId: Number },
  methods: {
    GoBack() {
      this.CancelComments = null;
      this.$validator.errors.remove("CancelComments");
      var vm = this;
      this.$store.commit(ACTIONS.CANCEL_TRANSACTION_SUCCESS);
      setTimeout(function () {
        vm.DeleteConfirm = false;
      }, 100);
    },
    Delete() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var params = new URLSearchParams();
          params.append("RequestId", this.RequestId);
          if (this.CancelComments != null && this.CancelComments != "") {
            params.append("CancelComments", this.CancelComments);
          }
          var vm = this;
          this.$store
            .dispatch(ACTIONS.CANCEL_TRANSACTION, params)
            .then((res) => {
              var { data } = res;
              if (data && data.StatusCode == 200) {
                vm.success_message = "Transaction Deleted";
                vm.DeleteConfirm = false;
                setTimeout(function () {
                  vm.success_message = null;
                  vm.CloseModal();
                }, 1500);
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    vm.$validator.errors.add({
                      field: prop,
                      msg: ResponseData[prop],
                    });
                  }
                }
              } else if (
                data &&
                (data.StatusCode == 500 ||
                  data.StatusCode == 403 ||
                  data.StatusCode == 2 ||
                  data.StatusCode == 429 ||
                  data.StatusCode == 1 ||
                  data.StatusCode == 406 ||
                  data.StatusCode == 0)
              ) {
              } else {
                vm.DeleteConfirm = false;
                vm.CancelComments = "";
                console.log(res);
              }
            })
            .catch((err) => {
              vm.DeleteConfirm = false;
              vm.CancelComments = "";
              console.log(err);
            });
        }
      });
    },
    saveRequest() {
      var params = new URLSearchParams();
      if (this.RequestId) {
        params.append("RequestId", this.RequestId);
      }
      params.append("Sell", true);
      var vm = this;
      this.$store
        .dispatch(ACTIONS.SALE_CONFIRMATION_SAVE, params)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            vm.success_message = "Transaction Updated Successfully";
            setTimeout(function () {
              vm.success_message = null;
              vm.CloseModal();
            }, 1500);
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    GetData() {
      var Url = "?id=" + (this.RequestId == null ? 0 : this.RequestId);
      var vm = this;
      this.$store
        .dispatch(ACTIONS.BUY_REQUEST_GET, Url)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            var { buyRequest } = data.ResponseData;
            if (vm.RequestId > 0) {
              vm.DeptId = buyRequest.DeptId;
              vm.ApplicationDate = vm.setDate(buyRequest.ApplicationDate);
              vm.ClientName = buyRequest.ClientName;
              vm.CurrencyId = buyRequest.Currency;
              vm.Commodity = buyRequest.Commodityid;
              //vm.DeptId = buyRequest.RequestType;
              vm.FajrReferenceId = buyRequest.RequestId;
              vm.YourRefrence = buyRequest.BankReference;

              vm.ValueDate = vm.setDate(buyRequest.ValueDate);
              vm.MaturityDate = vm.setDate(buyRequest.MaturityDate);
              //vm.PurchaseComment = buyRequest.PurchaseComment;
              vm.Comments = buyRequest.PurchaseComment;
              vm.TransactionTypeId = buyRequest.TransactionType;
              vm.FajrReferenceNo = buyRequest.RefNo;
              vm.UnitPrice = buyRequest.UnitPrice;
              vm.Amount = buyRequest.Amount;
              vm.Quantity = buyRequest.Quantity;
              vm.SellAccepted = buyRequest.SellAccepted;
            } else {
              vm.FajrReferenceNo = buyRequest.RefNo;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    CloseModal() {
      this.$emit("Close");
    },
  },
  beforeMount() {
    this.ApplicationDate = this.setDate();
    this.GetData();
  },
  computed: {
    ...mapGetters({
      PageSize: "PageSize",

      errorMessage: "GETBUYREQUESTSAVEERROR",
      loading: "GETBUYREQUESTSAVELOADING",
      RoleId: "RoleId",
      Departments: "GETREQUESTDEPARTMENTS",
      Currency: "GETCURRENCY",
      BankCommodities: "GETBUYREQUESTBANKCOMMODITIES",
      ClientNames: "GETCLIENTNAMES",
      TRANSACTIONTYPE: "GETTRANSACTIONTYPE",

      CONFIRMATIONLOADING: "GETCANCELLOADING",
      CONFIRMATIONERROR: "GETCANCELERROR",
    }),
  },
};
</script>